import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Search } from "lucide-react";
import api from "@/lib/api";
import { SongCard } from "@/components/SongCard";

const GENRES = ["", "synthwave", "hip-hop", "pop", "edm", "lo-fi", "cinematic", "rock", "r&b", "electronic"];

export default function Explore() {
  const [sp, setSp] = useSearchParams();
  const [q, setQ] = useState(sp.get("q") || "");
  const [genre, setGenre] = useState(sp.get("genre") || "");
  const [songs, setSongs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get("/songs", { params: { section: "trending", q, genre, limit: 60 } })
      .then((r) => setSongs(r.data.songs)).catch(() => {}).finally(() => setLoading(false));
  }, [q, genre]);

  const onSearch = (e) => { e.preventDefault(); setSp(q ? { q } : {}); };

  return (
    <div className="px-4 sm:px-6 lg:px-8 pt-4 lg:pt-6">
      <h1 className="text-2xl font-bold font-display mb-4">Explore</h1>
      <form onSubmit={onSearch} className="relative mb-5 max-w-xl">
        <Search size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-500" />
        <input value={q} onChange={(e) => setQ(e.target.value)} data-testid="explore-search" placeholder="Search songs, creators, genres…"
          className="w-full bg-[#121217] border border-white/10 rounded-full pl-10 pr-4 py-3 text-sm focus:outline-none focus:border-purple-500/50" />
      </form>
      <div className="flex gap-2 overflow-x-auto no-scrollbar pb-2 mb-6">
        {GENRES.map((g) => (
          <button key={g || "all"} onClick={() => setGenre(g)} data-testid={`genre-${g || "all"}`}
            className={`shrink-0 px-4 py-2 rounded-full text-sm capitalize border transition-colors ${genre === g ? "jx-cta text-white border-transparent" : "bg-white/5 border-white/10 text-slate-300"}`}>
            {g || "All"}
          </button>
        ))}
      </div>
      {loading ? (
        <p className="text-slate-500 py-10 text-center">Loading…</p>
      ) : songs.length === 0 ? (
        <p className="text-slate-500 py-10 text-center">No songs found. Try a different search or genre.</p>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 xl:grid-cols-5 gap-4">
          {songs.map((s) => <div key={s.id} className="flex justify-center"><SongCard song={s} list={songs} /></div>)}
        </div>
      )}
    </div>
  );
}
